/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Products',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/products'
    }
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'Dashboard',
        title: 'Dashboard',
        type : 'basic',
        icon : 'heroicons_outline:chart-bar',
        link : '/home'
    },
    {
        id   : 'products',
        title: 'Products',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/admin/products'
    },
    // {
    //     id   : 'add-product',
    //     title: 'Add Product',
    //     type : 'basic',
    //     icon : 'heroicons_outline:plus-circle',
    //     link : '/admin/add-product'
    // },
    // إضافة عناصر جديدة هنا
    {
        id   : 'categories',
        title: 'Categories',
        type : 'basic',
        icon : 'heroicons_outline:tag',
        link : '/admin/categories'
    },
    {
        id   : 'brands',
        title: 'Brands',
        type : 'basic',
        icon : 'heroicons_outline:cube-transparent',
        link : '/admin/brands'
    },
    {
        id   : 'units',
        title: 'Units',
        type : 'basic',
        icon : 'heroicons_outline:inbox-stack',
        link : '/admin/units'
    },
    {
        id   : 'variants',
        title: 'Variants',
        type : 'basic',
        icon : 'heroicons_outline:lifebuoy',
        link : '/admin/variants'
    },
    {
        id   : 'users',
        title: 'Users',
        type : 'basic',
        icon : 'heroicons_outline:users',
        link : '/admin/users'
    },
    {
        id   : 'orders',
        title: 'Orders',
        type : 'basic',
        icon : 'heroicons_outline:shopping-cart',
        link : '/admin/orders'
    },
    // {
    //     id   : 'reservations',
    //     title: 'Reservations',
    //     type : 'basic',
    //     icon : 'heroicons_outline:bookmark-square',
    //     link : '/admin/reservations'
    // },
    {
        id   : 'MenuDays',
        title: 'MenuDays',
        type : 'basic',
        icon : 'heroicons_outline:arrow-down-tray',
        link : '/admin/MenuDays'
    },
    {
        id   : 'Gallary',
        title: 'Gallary',
        type : 'basic',
        icon : 'heroicons_outline:photo',
        link : '/admin/gallery'
    },
    {
        id   : 'Banners',
        title: 'Banners&Sliders',
        type : 'basic',
        icon : 'heroicons_outline:film',
        link : '/admin/banners'
    },
    // 🔥 تم تغيير الأيقونة من film إلى fire
    {
        id   : 'Cooking Type',
        title: 'Cooking Type',
        type : 'basic',
        icon : 'heroicons_outline:fire',
        link : '/admin/cooking-type'
    }
];